import {Component, inject, Inject, OnInit, ViewChild} from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { User } from 'src/app/models/user.model';
import { AuthService } from '../../services/auth-service/auth.service';
import { LocalStorageService } from '../../services/localStorage-service/local-storage.service';
import { UserLanguageService } from '../../services/user-language-service/user-language.service';
import { UserDashboardService } from '../../user-dashboard.service';
import {AdminLanguageService} from '../../services/admin-language-service/admin-language.service';
import {Router} from '@angular/router';

@Component({
    selector: 'app-wrong-answer-modal',
    templateUrl: './wrong-answer-modal.html',
    styleUrls: ['./wrong-answer-modal.scss'],
    standalone: false
})
export class WrongAnswerModal implements OnInit {
  user: User
  userSub: Subscription;
  labels;
  labelsSub: Subscription;
  constructor(@Inject(MAT_DIALOG_DATA) public data, private router: Router, private localStorageService: LocalStorageService, private authService: AuthService, public dialogRef2: MatDialogRef<WrongAnswerModal>, public adminLanguageService: AdminLanguageService) { }

  ngOnInit(): void {
    this.labelsSub = this.adminLanguageService.labels$.subscribe((labels) => {
      this.labels = labels;
    })
  }
  onNoClick(){
    this.dialogRef2.close()
  }

}
